import Immutable from 'immutable';
import { Punch } from 'records/Punch';

export interface RawUpdatePunch {
  type: string;
  punch: Punch;
  viewerOverlay: boolean;
  fileid: string;
  containerStyles: React.CSSProperties;
  // sheetversion: SheetVersion;
}

export interface UpdatePunchData {
  type: string;
  punch: Punch;
  viewerOverlay: boolean;
  fileid: string;
  containerStyles: React.CSSProperties;
  // sheetversion: SheetVersion;
}

const defaultValues: UpdatePunchData = {
  type: 'UpdatePunch',
  punch: new Punch(),
  viewerOverlay: false,
  fileid: '',
  containerStyles: {},
  // sheetversion: new SheetVersion(),
};

export const UpdatePunchFactory = Immutable.Record(
  defaultValues,
  'UpdatePunch'
);

export class UpdatePunch extends UpdatePunchFactory {
  static deserialize(rawUpdatePunch: RawUpdatePunch): UpdatePunch {
    return new UpdatePunch({
      ...rawUpdatePunch,
    });
  }

  serialize(): RawUpdatePunch {
    return this.toJS();
  }
}
